import { render } from "./StepTwo.vue?vue&type=template&id=4caf2c67&scoped=true"
import script from "./StepTwo.vue?vue&type=script&lang=js"
export * from "./StepTwo.vue?vue&type=script&lang=js"

import "./StepTwo.vue?vue&type=style&index=0&id=4caf2c67&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4caf2c67"]])

export default __exports__